<script setup lang="ts">
  import { ref } from 'vue';
  import type { BranchMember } from '@/entities/Branch';
  import type { useOnboardingMinistrantes } from '../model/useOnboardingMinistrantes';
  import OnboardingMinistranteRow from './onboarding/OnboardingMinistranteRow.vue';

  defineProps<{
    ministrantes: ReturnType<typeof useOnboardingMinistrantes>;
    members: BranchMember[];
    memberOptions: { id: number; name: string }[];
  }>();

  const datePickers = ref<Record<number, boolean>>({});

  function getDatePickerOpen(rowId: number): boolean {
    return datePickers.value[rowId] ?? false;
  }

  function setDatePickerOpen(rowId: number, open: boolean): void {
    datePickers.value[rowId] = open;
  }
</script>

<template>
  <div
    v-for="(row, index) in ministrantes.rows.value"
    :key="row.id"
    class="border-b border-gray-02 px-6 py-8"
  >
    <OnboardingMinistranteRow
      :row="row"
      :members="members"
      :member-options="memberOptions"
      :is-first="index === 0"
      :is-add-disabled="!ministrantes.canAddMore.value"
      :date-picker-open="getDatePickerOpen(row.id)"
      @update:responsible-member-id="ministrantes.setResponsibleMemberId(index, $event)"
      @update:responsible-user-position-id="ministrantes.setResponsibleUserPositionId(index, $event)"
      @update:training-date="ministrantes.setTrainingDate(index, $event)"
      @update:date-picker-open="setDatePickerOpen(row.id, $event)"
      @add="ministrantes.addRow()"
      @remove="ministrantes.removeRow(index)"
    />
  </div>
</template>
